import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 150px;
  color: white;
  font-weight: 400;
  font-size: 20px;
  background: #11465d;
  border-radius: 5px;
`;
